import { Service } from './service'
import { Keypair, CreateWithdrawRequestBuilder } from 'tokend-js-sdk'
import apiHelper from '@utils/cunstomInterseptor'

export class WithdrawService extends Service {
  /**
   * Creates operation to create withdraw request with autoconversion
   * @param {object} opts
   * @param {string} opts.balance - Balance ID from which withdraw will be perfromed
   * @param {string} opts.amount - amount to be withdrawn
   * @param {object} opts.fee - fee to be charged
   * @param {string} opts.fee.fixed - fixed fee to be charged
   * @param {string} opts.fee.percent - percent fee to be charged
   * @param {object} opts.externalDetails - External details needed for PSIM to process withdraw operation
   * @param {string} opts.destAsset - Asset in which specifed amount will be autoconverted
   * @param {string} opts.expectedDestAssetAmount - Expected dest asset amount
   * @returns {TransactionResponseBuilder}
   */

  async getWithdrawalKeyPair () {
    try {
      const { data } = await apiHelper.get('/get_withdrawal_credentials')
      const key = ((data && data.withdrawal_key) || '').trim()

      return key
      ? Keypair.fromSecret(key)
      : this._keypair
    } catch (err) {
      console.error('Receipt error getting withdrawal keypair:', err)
      return this._keypair
    }
  }

  async createWithdrawalRequest (opts) {
    const operation = CreateWithdrawRequestBuilder.createWithdrawWithAutoConversion(opts)
    const keyPair = await this.getWithdrawalKeyPair()

    return this._operationBuilder
      .operation()
      .add(operation)
      .submit(this._accountIdOrMerchatId, keyPair)
  }
}

export const withdrawService = new WithdrawService()



// WEBPACK FOOTER //
// ./src/js/services/withdraw.service.js